// extracted by mini-css-extract-plugin
module.exports = {"center-content":"Notification_center-content__3CdFN","debugBorder":"Notification_debugBorder__1Murs","root":"Notification_root__1gsUn","icon":"Notification_icon__kfWFP"};